'use es6';

import memoize from 'transmute/memoize';
import { getStatus, getData } from './getters';
import { STARTED } from '../constants/senderKeyConstants';

/**
 * @deprecated use `conversations-async-data/async-data/operators/statusComparators` instead
 */
export const isSenderLoading = memoize(sender => !getData(sender) && getStatus(sender) === STARTED);